import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  footer, footerTitle, footerContent, footerList,
  listTitle, listUl, footerForm, socialIcons,
  divider, bottomFooter, leftSide, rightSide,
  flexRow, footerNewsletter, contactCol, footerContainer,
  mobileView, desktopView, accordionIcon, accordionIconOpen, hideFooterNewsletterMob
} from "./style.mod.scss";

import facebookIcon from "assets/images/social/fb.svg";
import instagramIcon from "assets/images/social/insta.svg";
import pinterestIcon from "assets/images/social/pint.svg";
import Link from "components/link";
import { ChevronDown } from "react-bootstrap-icons";

import locale from "locales";
import ActiveCampaignForm from "components/active-campaign-form";

const TextLinks = ({ links }) => {
  const Links = links.map((lnkGroup) => {
    const groupLinks = lnkGroup.links.map((lnk) => (
      <li key={lnk._key} className="">
        <Link to={lnk.url}>{lnk.title}</Link>
      </li>
    ));

    const [open, setOpen] = useState(false);

    return (
      <div key={lnkGroup._key} className={footerList}>
        <p className={listTitle} onClick={() => setOpen(!open)}>{lnkGroup.title}
          <span className={`${accordionIcon} ${open === true ? accordionIconOpen : ""}`}>
            <ChevronDown />
          </span></p>

        {open &&
          <ul className={`${listUl} ${mobileView}`}>
            {groupLinks}
          </ul>}

        <ul className={`${listUl} ${desktopView}`}>
          {groupLinks}
        </ul>
      </div>
    );
  });

  return Links;
};

const Footer = ({ sliceContext, hideFooterNewsletter }) => {

  const { footerSettings, socialSettings } = sliceContext;

  return (
    <div className={footer}>
      <div className={footerContainer}>
        <Row>
          <Col lg="8" xl="8" sm="12" className="p-0 m-0">
            <h2 className={footerTitle}>{footerSettings.title}</h2>
            <div className={footerContent}>
              <TextLinks links={footerSettings.links} />
            </div>
          </Col>
          <Col md="12" xl="4" lg="4" sm="12" className={`${flexRow} ${"p-0 m-0"}`}>
            <div className={hideFooterNewsletter && footerForm}>
              <h2 className={footerNewsletter}>{locale.footer.formTitle}</h2>
              <div className={hideFooterNewsletter && hideFooterNewsletterMob}>
                <ActiveCampaignForm />
              </div>
            </div>
            <div className={contactCol}>
              <div className={socialIcons}>
                <Link to={socialSettings.facebook} target="_blank" rel="noreferrer">
                  <img src={facebookIcon} alt={locale.altText.facebookIcon} />
                </Link>
                <Link to={socialSettings.instagram} target="_blank" rel="noreferrer">
                  <img src={instagramIcon} alt={locale.altText.instagramIcon} />
                </Link>
                <Link to={socialSettings.pinterest} target="_blank" rel="noreferrer">
                  <img src={pinterestIcon} alt={locale.altText.pinterestIcon} />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="12" style={{
            paddingLeft: "0",
            paddingRight: "0"
          }}>
            <div className={divider}></div>
          </Col>
          <Col lg="12" style={{
            paddingLeft: "0",
            paddingRight: "0"
          }}>
            <div className={bottomFooter}>
              <div className={leftSide}>
                <h5>&copy; <Link to="/">Olavson</Link> {(new Date().getFullYear())} </h5>
              </div>
              <div className={rightSide}>
                {
                  footerSettings?.impressumLink?.map((lnk) => (
                    <h5 key={lnk._key}>
                      <Link to={lnk.url}>{lnk.title}</Link>
                    </h5>
                  ))
                }
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Footer;
